// extracted by mini-css-extract-plugin
export var cancelButton = "_m3-5";
export var content = "_m3-3";
export var createButton = "_m3-6";
export var drawerContainer = "_m3-0";
export var footer = "_m3-2";
export var header = "_m3-1";
export var orderFormColumn = "_m3-4";